// English interface labels only. Customer-written review titles and bodies stay in their original language.
const labels = {
  'Alle Bewertungen anzeigen': 'See all reviews',
  'Shop-Bewertung schreiben': 'Write a store review',
  'Bewertung schreiben': 'Write a review',
  'Bewertung': 'Rating',
  'Bewertungstitel': 'Review title',
  'Bewertungsinhalt': 'Review',
  'Geben Sie Ihrer Bewertung einen Titel': 'Give your review a title',
  'Beginnen Sie hier zu schreiben...': 'Start writing here...',
  'Bild/Video (optional)': 'Picture/video (optional)',
  'Anzeigename': 'Display name',
  'wird öffentlich angezeigt wie': 'displayed publicly as',
  'Anonym': 'Anonymous',
  'E-Mail-Adresse': 'Email address',
  'Ihre E-Mail-Adresse': 'Your email address',
  'Bewertung abbrechen': 'Cancel review',
  'Bewertung abschicken': 'Submit review',
  'Kundenfotos & -videos': 'Customer photos & videos',
  'Mehr sehen': 'See more',
  'Verifiziert': 'Verified',
  'Sortieren nach': 'Sort by',
  'Neueste': 'Most recent',
  'Höchste Bewertung': 'Highest rating',
  'Niedrigste Bewertung': 'Lowest rating',
  'Nur Bilder': 'Only pictures',
  'Bilder zuerst': 'Pictures first',
  'Videos zuerst': 'Videos first',
  'Hilfreichste': 'Most helpful',
  'Bewertung in Etsy geschrieben': 'Review submitted on Etsy',
  'Keine Bewertungen': 'No reviews yet',
  'Nutzungsbedingungen': 'Terms of Service',
  'Datenschutzrichtlinie': 'Privacy Policy',
  'Inhaltsrichtlinien': 'Content Policy',
  'Wie wir Ihre Daten verwenden: Wir kontaktieren Sie nur bezüglich der von Ihnen abgegebenen Bewertung und nur, wenn nötig. Durch das Absenden Ihrer Bewertung stimmen Sie den': 'How we use your data: We contact you about your review only when necessary. By submitting your review, you agree to the',
  ', der': ', the',
  'und den': 'and the',
  'von Judge.me zu.': 'of Judge.me.',
};
const preserve = '.jdgm-rev__body, .jdgm-rev__title, .jdgm-rev__author, .jdgm-rev__timestamp, .jdgm-rev__location, .jdgm-rev__prod-link';
function translated(value) {
  const key=value.trim();
  let replacement=labels[key];
  if (!replacement && /^Basierend auf \d+ Bewertungen$/.test(key)) replacement=key.replace(/^Basierend auf (\d+) Bewertungen$/, 'Based on $1 reviews');
  if (!replacement && /^\d+ Bewertungen$/.test(key)) replacement=key.replace(' Bewertungen',' reviews');
  if (!replacement && /^1 Bewertung$/.test(key)) replacement='1 review';
  if (!replacement && /^[\d.,]+ von 5$/.test(key)) replacement=key.replace(' von 5',' out of 5');
  return replacement ? value.replace(key,replacement) : value;
}
export function localizeReviewWidget(widget, productTitles={}) {
  const visit=(node)=>{
    if (node.nodeType===3) {
      if (node.parentElement?.closest(preserve+', textarea')) return;
      const next=translated(node.nodeValue);
      if (next!==node.nodeValue) node.nodeValue=next;
      return;
    }
    if (node.nodeType!==1) return;
    if (node.matches(preserve)) return;
    for(const attribute of ['aria-label','title','placeholder']) {
      const value=node.getAttribute(attribute);
      if(value){const next=translated(value);if(next!==value)node.setAttribute(attribute,next);}
    }
    if(node.matches('input[type="submit"]')) {
      const value=node.getAttribute('value');const next=translated(value||'');
      if(next!==value)node.setAttribute('value',next);
    }
    for(const child of Array.from(node.childNodes))visit(child);
  };
  visit(widget);
  const view=widget.ownerDocument.defaultView;
  if(view?.getComputedStyle) {
    for(const thumbnail of widget.querySelectorAll('.jdgm-gallery__thumbnail-wrapper')) {
      if(view.getComputedStyle(thumbnail,'::before').content.includes('Mehr sehen'))thumbnail.classList.add('sw-review-more');
    }
  }
  for(const link of widget.querySelectorAll('.jdgm-rev__prod-link')) {
    const original=link.getAttribute('href')||'';
    const match=original.match(/^\/(?:en\/)?products\/([^?#/]+)(.*)$/);
    if(!match)continue;
    const target='/en/products/'+match[1]+match[2];
    if(original!==target)link.setAttribute('href',target);
    if(productTitles[match[1]]&&link.textContent.trim()!==productTitles[match[1]])link.textContent=productTitles[match[1]];
  }
}
function start() {
  if(document.documentElement.lang!=='en')return;
  const productTitles=JSON.parse(document.querySelector('#sproutwerk-review-products')?.textContent||'{}');
  const watched=new WeakSet();
  const watchWidget=(widget)=>{
    if(watched.has(widget))return;
    watched.add(widget);
    localizeReviewWidget(widget,productTitles);
    const observer=new MutationObserver(()=>localizeReviewWidget(widget,productTitles));
    observer.observe(widget,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','title','placeholder','value']});
  };
  const discover=(root)=>{
    if(root.nodeType!==1)return;
    if(root.matches('.jdgm-widget'))watchWidget(root);
    for(const widget of root.querySelectorAll('.jdgm-widget'))watchWidget(widget);
  };
  const discoveryObserver=new MutationObserver((mutations)=>{
    for(const mutation of mutations){
      const widget=mutation.target.closest?.('.jdgm-widget');
      if(widget)watchWidget(widget);
      for(const node of mutation.addedNodes)discover(node);
    }
  });
  discoveryObserver.observe(document.body,{subtree:true,childList:true});
  discover(document.body);
}
if(typeof document!=='undefined') {
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
}
